export enum Co2MeasureUnit {
  temperature = 'ºC',
  humidity = '%',
  co2 = 'PPM',
}
